import { render, staticRenderFns } from "./ActionPersonGoalkeeper.vue?vue&type=template&id=6fc040c6"
import script from "./ActionPersonGoalkeeper.vue?vue&type=script&lang=js"
export * from "./ActionPersonGoalkeeper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports